// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ACS5","title":"Header_title__xOPCt","left":"Header_left__qwukY","clinicName":"Header_clinicName__2nRsm"};